import script from "./CreateAndDeleteButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAndDeleteButtons.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAndDeleteButtons.vue?vue&type=style&index=0&id=65989a28&scooped=true&lang=css"

const __exports__ = script;

export default __exports__